<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-02 18:19:24
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-21 18:02:57
 * @FilePath: \partner.chaoyongtuan.com\src\views\talentCRM\ruleManage\ruleSet\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="main-content-padding">
		<Panel :contentPaddingTop="12" class="view-rules">
			<BreadCrumb slot="header">
				<div class="fz-14 yx-color-pure-1">编辑规则</div>
			</BreadCrumb>
			<div class="rule-set mt-12 yx-color-text-primary" v-loading="loading">
				<p class="yx-color-text-primary font-bold mb-16">跟进规则</p>
				<div class="mt-16">
					<div class="title yx-color-text-primary font-h4-medium">
						是否允许多个{{ drName }}跟进同一团长
						<span class="rule-explain yx-color-text-regular" @click="showRuleExplainDialog(2)">《规则说明》</span>
					</div>
					<el-radio-group class="mt-12 ml-16" :disabled="isWaitTask" v-model="manyPartnerToInstitution">
						<div class="flex-center">
							<div><el-radio label="1">允许</el-radio></div>
							<div class="ml-32">
								<el-radio label="0" class="flex-center">不允许</el-radio>
							</div>
						</div>
					</el-radio-group>
					<div class="content mt-16" v-if="isShowList">
						<div class="font-h4-regular">
							共计
							<span class="yx-color-primary">{{ talentList.length }}</span>
							个团长有多个{{ drName }}跟进，重新确认团长与{{ drName }}1对1跟进关系后，其余{{ drName }}关于该团长的合作进度将由最终跟进{{ drName }}继承
						</div>
						<el-table
							:data="talentList"
							border
							header-row-class-name="table-header-row"
							row-class-name="table-row"
							:cell-class-name="cellName"
							:span-method="arraySpanMethod"
							:header-cell-class-name="headerCellName"
							class="mt-16"
						>
							<el-table-column label="团长信息">
								<template v-slot="{ row }">
									<div class="talent-info">
										<yxAvatar :size="40" :placeholder="row.team_institution_name ? row.team_institution_name[0] : ''" />
										<div class="right">
											<div class="flex-row-align-center">
												<platform-icon :platformId="platformId" class="platform"></platform-icon>
												<div class="line-ellipsis-1 ml-4 fz-14 yx-color-text-primary">{{ row.team_institution_name }}</div>
											</div>
											<div class="mt-4">ID：{{ row.team_institution_id }}</div>
										</div>
									</div>
									<div class="error font-h6-regular" v-if="row.checked">
										<i class="el-icon-warning mr-8"></i>
										请选择{{ drName }}
									</div>
								</template>
							</el-table-column>
							<el-table-column :label="drName">
								<template v-slot="{ row }">
									<div
										:class="['partners', 'flex-row', !index ? 'top' : index + 1 === row.flowList.length ? 'bottom' : 'middle']"
										v-for="(item, index) in row.flowList"
										:key="index"
									>
										<p>{{ item.user_name }}</p>
										<label class="el-radio label-radio">
											<input type="radio" value="checked" @change="radioFun(row.flowList, index)" :name="row.userId" v-model="item.checked" />
											<span class="el-radio__label">设为最终跟进人</span>
										</label>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="200"></el-table-column>
							<template v-slot:empty v-if="true">
								<div class="empty mt-10 mb-20">
									<!-- <img src="@/assets/public/no-data-icon.png" alt="" /> -->
									<img src="@/assets/empty/empty-img@4x.png" style="width: 160px" />
									<p class="yx-color-text-secondary">暂无更正数据…</p>
								</div>
							</template>
						</el-table>
					</div>
				</div>
				<div class="footer pos-fix align-center yx-background-white radius-4">
					<el-button plain @click="cancel">取消</el-button>
					<el-button type="primary" @click="save" :disabled="isWaitTask">保存</el-button>
				</div>

				<rule-explain-dialog ref="ruleExplainDialog">
					<div>
						<p
							>1、若同个团长仅允许1个{{ drName }}跟进，系统会校验关系的唯一性，团长被录入/认领后，其他{{
								drName
							}}无法再录入/认领。同时该场景下团队所出订单会按{{ drName }}认领关系去进行归属</p
						>
						<p
							>2、若同个团长允许多个{{
								drName
							}}跟进，则系统会根据合作进度(商品、团长信息匹配)来归属业绩，对于未归属订单可在[订单管理]进行手动分配；</p
						>
						<p
							>3、{{ drName }}与团长跟进关系从多对1切换到1对1时，若存在多个{{
								drName
							}}同时跟进某个团长，管理员需为其指定1位最终跟进人。后续业绩归属也按唯一跟进人匹配，已归属订单业绩不会改动。</p
						>
					</div>
				</rule-explain-dialog>
			</div>
		</Panel>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import throttle from 'lodash/throttle';
import ruleExplainDialog from '@/components/business/ruleItem/ruleExplainDialog';
import { drRoleType } from '@/utils/dataMap';
import { GetRule, SetRule, institutionGetWaitFix } from '@/api/secondColonelManage';
import { tList } from './js/data';
export default {
	name: 'ruleSet',
	components: {
		ruleExplainDialog,
		
	},
	data() {
		return {
			isWaitTask: false,
			manyPartnerToInstitution: '1',
			talentList: [],
			platformId: +dataMap.PLATFORM_DY.value,
			waitFixNum: 0,
			loading: false,
			tList,
		};
	},
	created() {
		this.platformId = this.$route.query.platformId;
		this.GetRule();
	},
	computed: {
		...mapState(['vuex_userInfo']),
		drName() {
			return drRoleType.name;
		},
		isShowList({ manyPartnerToInstitution, waitFixNum, isWaitTask }) {
			return !isWaitTask && manyPartnerToInstitution === '0' && waitFixNum > 0;
		},
	},
	methods: {
		async GetRule() {
			this.loading = true;
			const { platformId } = this;
			try {
				const { manyPartnerToInstitution = '1', isWaitTask = false, fixFollowNum = 0 } = await GetRule({ platformId });
				this.manyPartnerToInstitution = `${manyPartnerToInstitution}`;
				this.isWaitTask = isWaitTask;
				this.waitFixNum = fixFollowNum;
				if (!this.isWaitTask && this.waitFixNum > 0) this.institutionGetWaitFix();
			} finally {
				this.loading = false;
			}
		},
		async institutionGetWaitFix() {
			const { platformId } = this;
			const { list = [] } = await institutionGetWaitFix({ platformId });
			this.talentList = list;
		},
		showRuleExplainDialog(flag) {
			const { platformId } = this;
			this.$refs.ruleExplainDialog.show(flag, platformId);
		},
		arraySpanMethod({ columnIndex }) {
			if (columnIndex === 1) {
				return [1, 2];
			}
		},
		cellName({ columnIndex }) {
			if (columnIndex === 1) return 'special';
		},
		headerCellName({ columnIndex }) {
			if (columnIndex === 1) return 'header-special';
		},
		radioFun(list, index) {
			list.forEach((item, ind) => {
				if (index !== ind) {
					delete item['checked'];
				}
			});
		},
		cancel() {
			this.$modal({
				title: '确认取消规则编辑？',
				contentTitle: '取消规则编辑将不会保存已编辑的规则',
				size: 'small',
			}).then(async res => {
				if (res.key == 'confirm') {
					this.back();
					res.done();
				} else {
					res.done();
				}
			});
		},
		switchChange(row) {
			if (row.value == '0') row.day = '';
		},
		save: throttle(async function () {
			let { manyPartnerToInstitution, platformId, drName } = this;
			let followInstitutionList = [];
			if (manyPartnerToInstitution === '0') {
				let state_list = [];
				this.talentList.forEach((item, index) => {
					item.flowList.forEach((it, ind) => {
						if (it.checked) {
							followInstitutionList.push({ id: it.id, teamInstitutionId: it.team_institution_id });
						}
					});
					let isChecked = item.flowList.some(ite => ite.checked);
					state_list.push(isChecked);
					if (isChecked) {
						this.$set(this.talentList[index], 'checked', false);
					} else {
						this.$set(this.talentList[index], 'checked', true);
					}
				});
				if (state_list.indexOf(false) !== -1) return this.$message.error(`请选择${drName}`);
			}
			let params = {
				manyPartnerToInstitution,
				followInstitutionList,
				platformId,
			};
			await SetRule(params); //设置是否允许多个商务跟进多个达人达人
			this.$message.success('操作成功');
			this.back();
		}, 1000),
		back() {
			let { platformId } = this;
			this.$router.push({
				path: '/secondColonelManage/rulesSetting/viewRules',
				query: {
					platformId,
				},
			});
		},
		handleClose(row) {
			this.$refs.delDialog.show(row);
		},
	},
};
</script>

<style lang="less" scoped>
.rule-set {
	padding-bottom: 88px;
	.title {
		.rule-explain {
			font-size: 14px;
			font-weight: 400;
			color: @color-primary;
			cursor: pointer;
		}
	}
	::v-deep .el-table__body-wrapper {
		max-height: 350px;
		overflow-y: auto;
	}
	.content {
		padding: 16px;
		background-color: #f9f9fa;
		border-radius: 4px;
	}
	.talent-info {
		display: flex;
		align-items: center;
		.right {
			margin-left: 8px;
			font-size: 12px;
			color: #4e596a;
			line-height: 18px;
			flex: 1;
			overflow: hidden;
			.platform {
				flex-shrink: 0;
			}
		}
	}
	.day-input {
		display: flex;
		align-items: center;
		white-space: nowrap;
		.el-input {
			width: 80px;
			margin: 0 6px;
		}
	}
	.flag {
		display: flex;
		align-items: center;
		&::before {
			content: '';
			width: 8px;
			height: 8px;
			border-radius: 50%;
			margin-right: 4px;
		}
		&.open::before {
			background-color: #0fb820;
		}
		&.close::before {
			background-color: #fa2d48;
		}
	}
	.partners {
		display: flex;
		justify-content: space-between;
		p {
			margin-left: 16px;
		}
	}
	.top {
		padding-bottom: 16px;
	}
	.middle {
		border-top: 1px solid #eaebf0;
		padding: 16px 0px;
	}
	.bottom {
		border-top: 1px solid #eaebf0;
		padding-top: 16px;
	}
	.label-radio {
		margin-right: 60px;
		display: flex;
		align-items: center;
		/deep/ input {
			color: @color-primary!important;
		}
	}
	.error {
		position: absolute;
		color: @color-danger;
	}
	::v-deep .special .cell {
		padding: 0px 0px !important;
	}
	::v-deep .header-special {
		border-right: 1px solid transparent !important;
	}
	.el-tag + .el-tag {
		margin-left: 10px;
	}
	.input-new-tag {
		width: 180px;
		margin-left: 10px;
		vertical-align: bottom;
		font-size: 12px;
		height: 20px;
		/deep/ .el-input__inner {
			height: 20px;
			line-height: 20px;
		}
	}
	.footer {
		width: calc(100% - 164px);
		right: 16px;
		bottom: 0px;
		height: 64px;
		line-height: 64px;
		box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.04);
	}
}
</style>
